import React, { Component } from 'react'
import { withStyles, Drawer, Typography, Divider, TextField, Button, AppBar, Toolbar, IconButton, FormControl, InputLabel, Select, OutlinedInput, MenuItem } from '@material-ui/core';

const drawerWidth = 500;

const styles = theme => ({
    root: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%'
    },
    textStyle: {
        fontWeight: 400
    },
    paddingForm: {
        padding: '20px'
    }
})

class CourseAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            award: '',
            year: '',
            type: '',
            award_type: '',
            id: ''
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);

    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidMount() {
        if (this.props.edit) {
            this.setState({
                ...this.props.edit_data
            })
        } else {
            this.setState({
                name: '',
                award: '',
                type: '',
                year: '',
                award_type: '',
                type: '',
                id: ''
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.edit !== this.props.edit) {
            if (this.props.edit) {
                this.setState({
                    ...this.props.edit_data
                })
            } else {
                this.setState({
                    name: '',
                    award: '',
                    type: '',
                    year: '',
                    award_type: '',
                    type: '',
                    id: ''
                })
            }
        }
    }


    onSubmit(e) {
        e.preventDefault();

        const data = this.state;

        if (this.props.edit) {
            this.props.esetData(data);

        } else {
            this.props.setData(data);
            this.setState({
                name: '',
                award: '',
                type: '',
                award_type: '',
                type: '',
                year: ''

            })
        }

    }

    onDeleteClick(id) {
        this.props.onDeleteClick(id);
    }

    render() {
        let { classes } = this.props;
        return (
            <div>
                <Drawer
                    className={classes.root}
                    anchor="right"
                    open={this.props.show}
                    onClose={this.props.handleClose}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >

                    <AppBar position="static" color={this.props.edit ? "secondary" : "primary"} >
                        <Toolbar>
                            <Typography variant="h6" color="inherit" >
                                {this.props.edit ? "Edit DATA" : "Add New"}
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <div className={classes.paddingForm}>

                        <form onSubmit={this.onSubmit}>
                            
                            <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                <InputLabel >
                                    Select Type
                    </InputLabel>
                                <Select
                                    value={this.state.type}
                                    onChange={this.onChange}
                                    input={
                                        <OutlinedInput labelWidth={200} name="type" />
                                    }
                                    required={true}
                                    name="type"

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    <MenuItem value="TEACHER">TEACHER</MenuItem>
                                    <MenuItem value="STUDENT">STUDENT</MenuItem>
                                </Select>
                            </FormControl>
                            <br></br>
                            <TextField
                                variant="outlined"
                                label="Name"
                                className={classes.textField}
                                type="text"
                                name="name"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.name}
                                onChange={this.onChange}
                            />



                            <TextField
                                variant="outlined"
                                label="Award"
                                className={classes.textField}
                                type="text"
                                name="award"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.award}
                                onChange={this.onChange}
                            />


                            <TextField
                                variant="outlined"
                                label="Year"
                                className={classes.textField}
                                type="number"
                                name="year"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.year}
                                onChange={this.onChange}
                            />

                            <br />
                            <div>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color={this.props.edit ? "secondary" : "primary"}
                                    className={classes.button}>
                                    {this.props.edit ? "Update" : "Submit"}
                                </Button>

                                {this.props.edit ?
                                    <span>&nbsp;
                                    <Button
                                            type="button"
                                            variant="contained"
                                            color="secondary"
                                            className={classes.button}
                                            onClick={this.onDeleteClick.bind(this, this.props.edit_data.id)}
                                        >
                                            Delete
                                    </Button>
                                    </span>

                                    : null}
                            </div>
                        </form>

                    </div>



                </Drawer>
            </div>
        )
    }
}

export default withStyles(styles)(CourseAdd)


// WEBPACK FOOTER //
// ./src/Components/Master/Course/CourseAdd.js